import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";

import PageTemplate from "../Templates/PageTemplate";
import middleware from "../Api/Middleware";
import exportOptions from "./Components/exportOptions";
import handleExcelDownloadCloud from "./Components/handleExcelDownloadCloud";
import { BackButton } from "../HouseStyle/Components/Buttons";

function ExportInfoPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isCSV, setIsCSV] = useState(false);
    const [downloadDisabled, setDownloadDisabled] = useState(false);
    const [exportDetails, setExportDetails] = useState({});
    const { export_id } = useParams();

    //Refs
    const downloadDebounce = useRef(false);

    // Fetch details of current export
    const fetchDetails = async () => {
        try {
            // Fetch results
            const exportDetailsResult = await middleware.get(`sp/exportDetails?export_id=${export_id}`);
            
            // Set data
            if (exportDetailsResult.data[0]) {
                setExportDetails(exportDetailsResult.data[0]);
            }
        } catch (error) {
            console.error("Error fetching import data:", error);
        }

        setLoading(false);
    };
    // Download the exported data
    const DownloadCSV = () => {
        if (!downloadDebounce.current) {
            setDownloadDisabled(true);
            downloadDebounce.current = true;
            handleExcelDownloadCloud(export_id, "export/get-file-url", isCSV ? "csv" : "xlsx");
            // const base64Data = exportDetails.file_data;
            // const fileName = `${exportDetails.description}`;
            // handleExcelDownload(base64Data, fileName, ";", isCSV);
            setTimeout(function() {
                downloadDebounce.current = false
                setDownloadDisabled(false);
            }, 1000)
        }
    };

    // Fetch only once when the page loads in 
    useEffect(() => {
        fetchDetails();
    }, []);

    return (
        <PageTemplate
            pageIsLoading={loading}
            navbarTitle={"Export Details"}
        >
            <div className="import-layout">
                <div className="d-flex mb-3 justify-content-between">
                    <div className="d-flex gap-3 align-items-center">
                        <BackButton text={`Terug`} onClickFunction={() => navigate('/import-export-center#imports')} />
                    </div>
                </div>

                <div className="whiteBox w-100 p-4">
                    <h1>{exportDetails.description}</h1>
        
                    {/* Export Type Badge */}
                    {exportOptions.exportTypes[exportDetails.table_name] && (
                        <div className="mb-3 d-flex gap-2 align-items-center">
                            <p className="mb-0">Type:</p>
                            <span
                                className="badge text-white p-2"
                                style={{ fontSize: "0.9rem", borderRadius: "10px", backgroundColor: "#025a7a" }}
                            >
                                {exportOptions.exportTypes[exportDetails.table_name].displayName}
                            </span>
                        </div>
                    )}
        
                    {/* Selected Groups with Badge Styling */}
                    {exportDetails.selected_groups_label && (
                        <div className="mb-3">
                            <span className="d-block mb-2">Geselecteerde groepopties:</span>
                            <div className="d-flex flex-wrap gap-2 align-content-center">
                                {exportDetails.selected_groups_label.split(", ").map((group, index) => (
                                    <span
                                        key={index}
                                        className="badge text-white p-2"
                                        style={{ fontSize: "0.9rem", borderRadius: "10px", backgroundColor: "#009fe3" }}
                                    >
                                        {group}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
        
                    <p>Gestart door: <b>{exportDetails.username}</b></p>
                    <p>
                        Gestart op:{" "}<b>{exportDetails.created_at
                            ? format(new Date(exportDetails.created_at), "dd-MM-yyyy HH:mm:ss")
                            : "Onbekende datum"}</b>
                    </p>
        
                    {/* Toggle between XLSX and CSV */}
                    <div className="mb-3">
                        <p className="mb-2 fw-semibold text-uppercase text-muted" style={{ letterSpacing: "0.08em", fontSize: "0.75rem" }}>
                            Bestandsformaat
                        </p>
                        <div className="format-toggle" role="radiogroup" aria-label="Bestandsformaat">
                            <label className={`toggle-option ${isCSV ? "active" : ""}`}>
                                <input
                                    className="toggle-input"
                                    type="radio"
                                    name="export-format"
                                    value="csv"
                                    checked={isCSV}
                                    onChange={() => setIsCSV(true)}
                                />
                                <span>CSV</span>
                                <small>Compatibel met spreadsheet tools</small>
                            </label>
                            <label className={`toggle-option ${!isCSV ? "active" : ""}`}>
                                <input
                                    className="toggle-input"
                                    type="radio"
                                    name="export-format"
                                    value="xlsx"
                                    checked={!isCSV}
                                    onChange={() => setIsCSV(false)}
                                />
                                <span>XLSX</span>
                                <small>Beste keuze voor Excel</small>
                            </label>
                        </div>
                    </div>
        
                    {/* Download file */}
                    <div>
                        <button
                            onClick={DownloadCSV}
                            disabled={
                                (!exportDetails.csv_path && !exportDetails.xlsx_path) || downloadDisabled
                            }
                            className="btn btn-success me-2"
                            style={{
                                background: "linear-gradient(145deg, #4CAF50, #66BB6A)",
                                border: "none",
                                borderRadius: "5px",
                            }}
                        >
                            <FontAwesomeIcon icon={faCloudArrowDown} /> Download bestand
                        </button>
                        <span>
                            {!exportDetails.csv_path && !exportDetails.xlsx_path ? (
                                <b className="text-danger">(Download verlopen)</b>
                            ) : (
                                <span>
                                    Verloopt op:{" "}
                                    <b>
                                        {exportDetails.file_expire_date
                                            ? format(
                                                new Date(exportDetails.file_expire_date),
                                                "dd-MM-yyyy HH:mm:ss"
                                            )
                                            : "Onbekende datum"}
                                    </b>
                                </span>
                            )}
                        </span>
                    </div>
                </div>
            </div>
        </PageTemplate>
    );
    
    
}

export default ExportInfoPage;